export const MODAL_SAVE_WORD_LIST = "saveWordsList";
export const MODAL_DELETE_WORD_LIST = "deleteWordsList";
